import { FilterPagingCriteria } from "../../shared/dataModels";

export class HiddenFilters {
    hideStartDate: boolean = false;
    hideEndDate: boolean = false;
    hideVehicleType: boolean = false;
    hideManufacturer: boolean = false;
    hideBrand: boolean = false;
    hideBranch: boolean = false;
    hideModel: boolean = false;
    hideVehicle: boolean = false;
    hideGroup: boolean = false;
    hideGeofence: boolean = false;
    hideSensor: boolean = false;
    hideDriver: boolean = false;
    singleVehicleSelect?: boolean = false;
    singleVehicleTypeSelect?: boolean = false;
    showNotificationChannel?: boolean = true;
}
export class PopupVicle{
    Photo: any;
    Long: any;
    Lat: any;
    Address: any;
    Date: any;
    Plate: any;
    Code: any;
    TypeId: any;
   Value: any;
   Staff?: any;
   IButton? : any;
    RFId?: any;
    StaffRole: string = "";
    Sensors?: any[] = [];
    
}
export class FiltersModel {
    StartDate: Date;
    EndDate: Date;
    strStartDate: string;
    strEndDate: string;
    VehicleTypeIds: number[] = [];
    ManufacturerIds: number[] = [];
    BrandIds: number[] = [];
    BranchIds: number[] = [];
    ModelIds: number[] = [];
    VehicleIds: number[] = [];
    VehicleGroupIds: number[] = [];
    GeofenceIds: number[] = [];
    DriverIds: number[] = [];
    SensorIds: number[] = [];
    PageCriteria: FilterPagingCriteria;
    NotificationChannelIds: number[] = [];
    applyPaging: boolean = true;
    constructor(date?: Date, PageCriteria?: FilterPagingCriteria) {
        this.StartDate = this.EndDate = date;
        this.PageCriteria = PageCriteria;
    }
}

export class ReportColumn {
    name: string;
    type: string;
    visible: boolean;
}

export class GoogleAddress {
    lon: number;
    lat: number;
    Address?: string;
    KEY?: string;
}

export enum AddressSourceEnum {
    Google,
    Esri,
    OpenLayers
}
 
export enum EventTypeEnum {
    Moving = 1,
    Idle,
    Parking,
    Towing,
    Unplugged,
    PanicMoniter,
    SpeedMonitor,
    SpeedViolation,
    GeofenceInMonitor,
    GeofenceInViolation = 11,
    GeofenceOutViolation,
    DoorViolation = 14,
    SeatBeltViolation = 16,
    TemperatureViolation = 18,
    Disconnected,
    PanicViolation = 22
}

export enum GeofenceCreationTypeEnum {
    Any = 0,
    SystemGenerated,
    Auto,
    Manual,
}

export class GraphObject {
    public title: string;
    public ActionDate: any;
    public FullDate: Date;
    public FormaterDate: string;
    public Value: any;
    public Vehicle: any;
    public Device: any;
    public Latitude: string;
    public Longitude: string;
    public Temp: string;
    public Speed: string;
    public Sensors: any[] = [];
    public SensorVaules: any[] = [];
};

export class GraphObjectExport {
    public FormaterDate: string;
    public Value: any;
    public Vehicle: any;
    public Device: any;
    public Latitude: string;
    public Longitude: string;
    public Sensors: any[] = [];
    public SensorVaules: any[] = [];

};


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/analytics/dataModels/staticReports.data-models.ts